"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHydrationHost = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var uuid_1 = require("uuid");
var HydrationContext_1 = require("./HydrationContext");
var ServerHydrationHost = function (_a) {
    var componentName = _a.componentName, hydrationData = _a.hydrationData, children = _a.children;
    var ref = react_1.default.useRef(0);
    var hostId = react_1.default.useMemo(function () { return (0, uuid_1.v4)(); }, []);
    return (react_1.default.createElement(HydrationContext_1.HydrationContext.Provider, { value: { hostId: hostId, contentAreaIndex: ref } },
        react_1.default.createElement("div", { "data-hydration-host": true, "data-hydration-host-id": hostId, "data-hydration-component": componentName, "data-hydration-data": JSON.stringify(hydrationData) }, children)));
};
var ClientHydrationHost = function (_a) {
    var hostId = _a.hostId, children = _a.children;
    var ref = react_1.default.useRef(0);
    return react_1.default.createElement(HydrationContext_1.HydrationContext.Provider, { value: { hostId: hostId, contentAreaIndex: ref } }, children);
};
var withHydrationHost = function (Comp, _a) {
    var componentName = _a.componentName, _b = _a.ignoreProps, ignoreProps = _b === void 0 ? [] : _b;
    var WrappedComponent = function (props) {
        var isClientSide = typeof document !== "undefined";
        if (isClientSide) {
            var hostId = props.hostId;
            if (!hostId) {
                return react_1.default.createElement(Comp, __assign({}, props));
            }
            else {
                return (react_1.default.createElement(ClientHydrationHost, { hostId: hostId },
                    react_1.default.createElement(Comp, __assign({}, props))));
            }
        }
        var hydrationData = (0, lodash_1.omit)(props, __spreadArray(__spreadArray([], __read(ignoreProps), false), ["di", "$scope"], false));
        return (react_1.default.createElement(ServerHydrationHost, { componentName: componentName, hydrationData: hydrationData },
            react_1.default.createElement(Comp, __assign({}, props))));
    };
    WrappedComponent.hydrationComponentName = componentName;
    return WrappedComponent;
};
exports.withHydrationHost = withHydrationHost;
